import {
    forwardRef,
    HTMLAttributes,
} from 'react';

import { cn, formatNumberShort } from '@/shared/lib/utils';

import ScreenIcon from "@/assets/icons/map_card_icons/screen.svg?react"
import MIcon from "@/assets/icons/map_card_icons/m.svg?react"
import FloorIcon from "@/assets/icons/map_card_icons/floor.svg?react"
import YearIcon from "@/assets/icons/map_card_icons/year.svg?react"
import { buildingType } from '@/entities/knowledge/model/types';
import { NavLink } from 'react-router-dom';

export interface KnowledgeMapCardProps extends HTMLAttributes<HTMLDivElement> {
    building: buildingType;
    additional?: { id: string, name: string, color: string }
    inMap?: boolean;
    wrClassName?: string;
}

export const KnowledgeMapCard = forwardRef<HTMLDivElement, KnowledgeMapCardProps>(
    ({ className, wrClassName, inMap, building, additional, ...props }, ref) => {

        return (
            <NavLink to={`/buildings/${building.id}`} className={wrClassName}>
                <div className={cn('flex flex-col overflow-hidden rounded-[10px] bg-white shadow-cls', inMap ? 'w-[238px]' : 'min-w-[306px] max-w-[360px] flex-1', className)}>
                    <img
                        className={cn('w-full object-cover object-center', inMap ? 'h-[100px]' : 'h-[150px]')}
                        src={building.imageUrl || "/images/search_widget_bg.png"}
                        alt=""
                    />

                    <div className={cn('flex flex-col', inMap ? 'p-[12px] pb-[8px] gap-[10px]' : 'px-[20px] py-[16px] gap-[12px]')}>
                        <span className={cn('normal uppercase font-[500] leading-[0.97em]', inMap ? 'text-[14px]' : 'text-[16px]')}>
                            {building.name}
                        </span>
                        <span className={cn('normal font-[500] text-[#00000099] leading-[0.97em]', inMap ? 'text-[12px]' : 'text-[14px]')}>
                            {building.developer}
                        </span>
                        <span className={cn('normal font-[500] leading-[0.97em]', inMap ? 'text-[12px]' : 'text-[12px]')} style={{ color: additional?.color }}>
                            {additional?.name}
                        </span>

                        <div className='flex flex-row gap-[4px] items-center'>
                            <div className='flex items-center gap-[2px]'>
                                <FloorIcon />
                                <span className={cn('text-[#00000099] whitespace-nowrap', inMap ? 'text-[10px]' : 'text-[12px]')}>
                                    {building.floors}
                                </span>
                            </div>
                            <div className='flex items-center gap-[2px]'>
                                <ScreenIcon />
                                <span className={cn('text-[#00000099] whitespace-nowrap', inMap ? 'text-[10px]' : 'text-[12px]')}>
                                    {building.totalArea.value} м²
                                </span>
                            </div>
                            <div className='flex items-center gap-[2px]'>
                                <YearIcon />
                                <span className={cn('text-[#00000099] whitespace-nowrap', inMap ? 'text-[10px]' : 'text-[12px]')}>
                                    {building.yearBuilt} год
                                </span>
                            </div>
                            <div className='flex items-center gap-[2px]'>
                                <MIcon />
                                <span className={cn('text-[#00000099] whitespace-nowrap', inMap ? 'text-[10px]' : 'text-[12px]')}>
                                    {building.district}
                                </span>
                            </div>
                        </div>

                        <div className='flex flex-row justify-between items-center'>
                            <span className={cn('font-roboto font-normal text-black leading-[130%] tracking-normal uppercase', inMap ? 'text-[14px]' : 'text-[16px]')}>
                                {formatNumberShort(building.price.from)}
                            </span>

                            <div className={cn('flex justify-center items-center bg-black text-white rounded-full  shadow-cls', inMap ? ' w-[24px] h-[24px]' : ' w-[30px] h-[30px]')}>
                                <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M-0.00010737 11.4856C-0.000746808 11.3489 0.0531968 11.2178 0.149539 11.1218L5.2307 5.99381L0.149539 0.865845C-0.0377632 0.662985 -0.0322362 0.346863 0.16204 0.150798C0.356315 -0.0452671 0.669551 -0.0508447 0.87056 0.138182L6.31223 5.62997C6.51116 5.83099 6.51116 6.15663 6.31223 6.35764L0.87056 11.8494C0.671383 12.0502 0.348715 12.0502 0.149539 11.8494C0.0531968 11.7534 -0.000746808 11.6223 -0.00010737 11.4856Z" fill="white" />
                                </svg>
                            </div>

                        </div>
                    </div>
                </div>
            </NavLink>
        );
    }
);

KnowledgeMapCard.displayName = 'KnowledgeMapCard';